import React, { Component } from "react";
import './about.css';

export default class About extends Component {

    public render() {

        return(
            <div id = "about">
                
                <p>Hello!</p>
                <p>This website simulates a programming website. Its a frontend only project, that shows state management without directly changing the DOM and different events that happen according to the user's actions.</p>

            </div>
        );
    }
}